import { render } from "./details-activities.vue?vue&type=template&id=31cdba1f&ts=true"
import script from "./details-activities.vue?vue&type=script&lang=ts"
export * from "./details-activities.vue?vue&type=script&lang=ts"

import "./details-activities.vue?vue&type=style&index=0&id=31cdba1f&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__